"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHoneymoonsNavItems = void 0;
var _navConstants = require("../constants/navConstants");
/**
 * Used in web-preauth
 */

var parent = _navConstants.PrimaryNavIdentifier.HONEYMOONS;
var hawaii = {
  title: 'Hawaii',
  path: '/wedding-planning/honeymoons/destination/hawaii',
  id: _navConstants.SecondaryNavIdentifier.DESTINATION_HAWAII,
  parent: parent
};
var caribbean = {
  title: 'Caribbean Islands',
  path: '/wedding-planning/honeymoons/destination/caribbean',
  id: _navConstants.SecondaryNavIdentifier.DESTINATION_CARIBBEAN,
  parent: parent
};
var italy = {
  title: 'Italy',
  path: '/wedding-planning/honeymoons/destination/italy',
  id: _navConstants.SecondaryNavIdentifier.DESTINATION_ITALY,
  parent: parent
};
var greece = {
  title: 'Greece',
  path: '/wedding-planning/honeymoons/destination/greece',
  id: _navConstants.SecondaryNavIdentifier.DESTINATION_GREECE,
  parent: parent
};
var france = {
  title: 'France',
  path: '/wedding-planning/honeymoons/destination/france',
  id: _navConstants.SecondaryNavIdentifier.DESTINATION_FRANCE,
  parent: parent
};
var spain = {
  title: 'Spain',
  path: '/wedding-planning/honeymoons/destination/spain',
  id: _navConstants.SecondaryNavIdentifier.DESTINATION_SPAIN,
  parent: parent
};
var bali = {
  title: 'Bali',
  path: '/wedding-planning/honeymoons/destination/bali',
  id: _navConstants.SecondaryNavIdentifier.DESTINATION_BALI,
  parent: parent
};
var maldives = {
  title: 'Maldives',
  path: '/wedding-planning/honeymoons/destination/maldives',
  id: _navConstants.SecondaryNavIdentifier.DESTINATION_MALDIVES,
  parent: parent
};
var floridaKeys = {
  title: 'Florida Keys',
  path: '/wedding-planning/honeymoons/destination/florida-keys',
  id: _navConstants.SecondaryNavIdentifier.DESTINATION_FLORIDA_KEYS,
  parent: parent
};
var napa = {
  title: 'Napa',
  path: '/wedding-planning/honeymoons/destination/napa',
  id: _navConstants.SecondaryNavIdentifier.DESTINATION_NAPA,
  parent: parent
};
var californiaCoast = {
  title: 'California Coast',
  path: '/wedding-planning/honeymoons/destination/california-coast',
  id: _navConstants.SecondaryNavIdentifier.DESTINATION_CALIFORNIA_COAST,
  parent: parent
};
var charleston = {
  title: 'Charleston',
  path: '/wedding-planning/honeymoons/destination/charleston',
  id: _navConstants.SecondaryNavIdentifier.DESTINATION_CHARLESTON,
  parent: parent
};
var parks = {
  title: 'National Parks',
  path: '/wedding-planning/honeymoons/destination/national-parks',
  id: _navConstants.SecondaryNavIdentifier.DESTINATION_NATIONAL_PARKS,
  parent: parent
};
var mexicoCentralAmerica = {
  title: 'Mexico & Central America',
  path: '/wedding-planning/honeymoons/destination/mexico-central-america',
  id: _navConstants.SecondaryNavIdentifier.DESTINATION_MEXICO_CENTRAL_AMERICA,
  parent: parent
};
var continentalUS = {
  title: 'Continental US',
  path: '/wedding-planning/honeymoons/destination/continental-us',
  id: _navConstants.SecondaryNavIdentifier.DESTINATION_CONTINENTAL_US,
  parent: parent,
  showCaret: true,
  children: [floridaKeys, californiaCoast, napa, charleston, parks]
};
var other = {
  title: 'Other',
  path: '/wedding-planning/honeymoons/destination/other',
  id: _navConstants.SecondaryNavIdentifier.DESTINATION_OTHER,
  parent: parent,
  children: [bali, maldives],
  showCaret: true
};
var europe = {
  title: 'Europe',
  path: '/wedding-planning/honeymoons/destination/europe',
  id: _navConstants.SecondaryNavIdentifier.DESTINATION_EUROPE,
  parent: parent,
  children: [italy, spain, france, greece],
  showCaret: true
};
var getHoneymoonsNavItems = exports.getHoneymoonsNavItems = function getHoneymoonsNavItems() {
  return [hawaii, caribbean, europe, mexicoCentralAmerica, continentalUS, other];
};